import React, { useState } from "react";
import CommonSegmentedTabs from "@/shared/components/ui/Tabs/SegmentedTabs";
import MessageComposer from "./MessageComposer";
import { TEMPLATE_CHANNELS } from "@/features/campaigns/utils/stepContentMode";

/** Email / LinkedIn / WhatsApp templates for a whole campaign. */
const CampaignMessageTemplates = ({
  value = {},
  onChange,
  errors = {},
  previewLeads = [],
  sender,
  initialChannel,
}) => {
  const [channel, setChannel] = useState(
    TEMPLATE_CHANNELS.some((item) => item.key === initialChannel) ? initialChannel : TEMPLATE_CHANNELS[0].key,
  );
  const entry = value?.[channel] ?? {};
  const update = (patch) => onChange?.({ ...value, [channel]: { ...entry, ...patch } });

  return (
    <div className="flex flex-col gap-4">
      <CommonSegmentedTabs
        selectedKey={channel}
        onSelectionChange={(key) => setChannel(String(key))}
        tabs={TEMPLATE_CHANNELS.map((item) => ({
          key: item.key,
          title: errors[item.key]?.length ? `${item.title} •` : item.title,
        }))}
      />
      <MessageComposer
        key={channel}
        channel={channel}
        subject={entry.subject ?? ""}
        onSubjectChange={(subject) => update({ subject })}
        body={entry.body ?? ""}
        onBodyChange={(body) => update({ body })}
        errors={errors[channel] ?? []}
        previewLeads={previewLeads}
        sender={sender}
      />
    </div>
  );
};

export default CampaignMessageTemplates;
